module.exports = __webpack_public_path__ + "static/media/saudi.84c41be5.jpg";